<template>
  <div class="small-print">
    <div class="small-print__content">
      <div class="small-print__title">Small Print You’re Going to Want to Read:</div>
      <div class="small-print__text">
        <p>{{ offerDatesText }}</p>
        <p>
          Discounts cannot be applied to previous orders or be combined with any other offer. We
          reserve the right to change or discontinue this offer at any time.
        </p>
      </div>
    </div>
    <div class="small-print__content">
      <ul>
        <li
          v-for="(print, index) in isCyberMondayActive ? cyberMondayPrints : blackFridayPrints"
          :key="index"
        >
          <span class="small-print__title">{{ print.title }}&nbsp;</span>
          <span class="small-print__text" v-html="print.content"></span>
          <ul v-if="print.subcontent">
            <li v-for="(sub, subIndex) in print.subcontent" :key="subIndex">
              <span class="small-print__text">{{ sub }}</span>
            </li>
          </ul>
        </li>
      </ul>
      <div class="small-print__text">
        If you have any questions, please email us at&nbsp;
        <a class="small-print__link" href="mailto:support@ine.com">support@ine.com</a>.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BFSmallPrint',
  props: {
    isCyberMondayActive: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    offerDatesText: 'This offer is valid November 22 through December 5, 2024.',
    blackFridayPrints: [
      {
        title: 'Premium Subscription + Skill Dive + Certification',
        content:
          'This option is for new subscribers only. INE Premium and Skill Dive subscriptions will auto-renew annually at the published rate (USD) after the initial purchase cost unless canceled prior to the subscriber’s renewal date. This offer is valid for initial Skill Dive purchase only. One Skill Dive learning area is included in this option. Additional Skill Dive learning areas may be purchased for $99. Skill Dive offers 240 lab hours annually. Lab hours DO NOT roll over annually. Additional lab hours can be purchased. Offer valid on new INE Security exam vouchers. Once purchased, the INE Security Certification exam voucher will be in your account and available to attempt for 180 days. You will have two attempts to pass the certification exam. This offer excludes ICCA.',
      },
      {
        title: 'Black Friday Option 2: Premium Subscription + Certification',
        content:
          'This option is for new subscribers only. INE Premium will auto-renew annually at the published rate (USD) after the initial purchase cost unless canceled prior to the subscriber’s renewal date. Offer valid on new INE Security exam vouchers. Once purchased, the INE Security Certification exam voucher will be in your account and available to attempt for 180 days. You will have two attempts to pass the certification exam. This offer excludes ICCA.',
      },
      {
        title: 'Black Friday Option 3: Fundamentals Annual + eJPT',
        content:
          'This option is for new subscribers only. INE Fundamentals Annual will auto-renew annually at the published rate (USD) after the initial purchase cost of $199 unless canceled prior to the subscriber’s renewal date.',
      },
      {
        title: 'Black Friday Option 4: INE Security Certifications',
        content:
          'Offer valid on new INE Security exam vouchers. Once purchased, the INE Security Certification exam voucher will be in your account and available to attempt for 180 days. You will have two attempts to pass the certification exam. eJPT, eCPPT, eWPT, and eEDA can only be purchased with Premium subscription or a +3 plan. This offer excludes ICCA.',
      },
    ],
    cyberMondayPrints: [
      {
        title: 'Premium Subscription + Skill Dive + Certification',
        content:
          'This option is for new subscribers only. INE Premium and Skill Dive subscriptions will auto-renew annually at the published rate (USD) after the initial purchase cost unless canceled prior to the subscriber’s renewal date. This offer is valid for initial Skill Dive purchase only. One Skill Dive learning area is included in this option. Additional Skill Dive learning areas may be purchased for $99. Skill Dive offers 240 lab hours annually. Lab hours DO NOT roll over annually. Additional lab hours can be purchased. Offer valid on new INE Security exam vouchers. Once purchased, the INE Security Certification exam voucher will be in your account and available to attempt for 180 days. You will have two attempts to pass the certification exam. This offer excludes ICCA.',
      },
      {
        title: 'Premium Subscription + Certification',
        content:
          'This option is for new subscribers only. INE Premium will auto-renew annually at the published rate (USD) after the initial purchase cost unless canceled prior to the subscriber’s renewal date. Offer valid on new INE Security exam vouchers. Once purchased, the INE Security Certification exam voucher will be in your account and available to attempt for 180 days. You will have two attempts to pass the certification exam. This offer excludes ICCA.',
      },
      {
        title: 'Fundamentals Annual + eJPT',
        content:
          'This option is for new subscribers only. INE Fundamentals Annual will auto-renew annually at the published rate (USD) after the initial purchase cost of $199 unless canceled prior to the subscriber’s renewal date.',
      },
      {
        title: 'INE Security Certifications',
        content:
          'Offer valid on new INE Security exam vouchers. Once purchased, the INE Security Certification exam voucher will be in your account and available to attempt for 180 days. You will have two attempts to pass the certification exam. eJPT, eCPPT, eWPT, and eEDA can only be purchased with Premium subscription or a +3 plan. This offer excludes ICCA.',
      },
      {
        title: 'Cyber Monday Option 1: 50% off Skill Dive',
        content:
          'This offer is valid for initial Skill Dive purchase only. One Skill Dive learning area is included in this option. Additional Skill Dive learning areas may be purchased for $99. Skill Dive offers 240 lab hours annually. Lab hours DO NOT roll over annually. Additional lab hours can be purchased.',
      },

      {
        title: 'Cyber Monday Option 2: 50% off Premium + 3 Months Training Bundles',
        content:
          'This option is for new subscribers only. <b style="color: var(--gray-9);">Code: CMCERTPLUS24</b>. This offer includes 50% off Premium subscription and 3 months of training bundles. The Premium subscription will auto-renew annually at the published rate (USD) after the initial purchase cost unless canceled prior to the subscriber’s renewal date. Training bundles are subject to availability and must be used within the 3-month period. This offer cannot be combined with any other discounts or promotions.',
        subcontent: [
          'eCPPT + three months of training includes three months of Premium subscription. Subscriber will be charged after the initial three month offer at the prorated price of $350.00 unless canceled prior to renewal.',
          'eEDA + three months of training includes three months of Premium subscription. Subscriber will be charged after the initial three month offer at the prorated price of $350.00 unless canceled prior to renewal.',
          'eWPT + three months of training includes three months of Premium subscription. Subscriber will be charged after the initial three month offer at the prorated price of $350.00 unless canceled prior to renewal. Offer valid on new eCPPT, eWPT, and eEDA exam vouchers, we reserve the right to change this offer at any time. Once purchased, the eCPPT, eWPT, or eEDA certification exam voucher will be in your account and available to attempt for 180 days. You will have two attempts to pass the certification exam.',
        ],
      },
      {
        title: 'Cyber Monday Option 3: 25% off ALL Live Virtual Trainings',
        content:
          'This offer is valid for any Live Virtual Training session. $25% off ANY Live Virtual Training, code <b style="color: var(--gray-9);">CMLVT252024</b>, is only valid through December 3, 2024. Offer valid for individual use only; Enterprise offers available through the sales department when purchasing for more than one learner. We reserve the right to change this offer at any time. Limited to one use per person and cannot be combined with any other offers, discounts, promotions, or other vouchers. Enrollment is subject to availability, registration, and adherence to the Company\'s enrollment policies.',
      },
    ],
  }),
}
</script>

<style lang="scss" scoped>
.small-print {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
  margin-bottom: 60px;

  @include tablet {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 60px;
    align-self: stretch;
  }
  ul {
    margin: 0;
    padding-left: 15px;
    line-height: 12px;
    li {
      line-height: 12px;
      margin-bottom: 10px;
      &::marker {
        color: var(--boulder);
      }
    }
    ul {
      margin-top: 10px;
      list-style-type: inherit;
    }
  }
  &__content {
    flex: 1 0 0;
  }
  &__content:first-child {
    @include tablet {
      max-width: 296px;
    }
  }
  &__title {
    color: var(--gray-9);
    font-size: rem(10px);
    font-style: normal;
    font-weight: 700;
    line-height: rem(12px);
  }
  &__text {
    color: var(--boulder);
    font-size: rem(10px);
    font-style: normal;
    font-weight: 450;
    line-height: rem(12px);
  }
  &__link {
    color: var(--light-purple);
    font-size: rem(10px);
    font-style: normal;
    font-weight: 450;
    line-height: rem(12px);
  }
}
</style>
